import React from "react";
import "./Terravia1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Adoraimages from "../../../Media/BSD/Terravia/Adora";
import Primesimages from "../../../Media/BSD/Terravia/Primes";
import Luxeimages from "../../../Media/BSD/Terravia/Luxe";
import Belovaimages from "../../../Media/BSD/Terravia/Belova";
import Castiloimages from "../../../Media/BSD/Terravia/Castilo/Castilo";

const imageMap = {
  Adoraimages,
  Primesimages,
  Luxeimages,
  Belovaimages,
  Castiloimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Briza" className="produk">
      <h1>Our Home</h1>
      <h2>Cicilan Start 8 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
